import React from 'react';
import { ToastContainer, Zoom } from "react-toastify";

export default function Toast() {
    return (
        <ToastContainer
          position="bottom-center"
          autoClose={6000}
          limit={3}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          theme="light"
          transition={Zoom}
        />
    );
}
